import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';
import UpdateLocale from 'dayjs/plugin/updateLocale';

export const applyDayJsConfig = () => {
    configEn();
    configEs();
};

const configEn = () => {
    const thresholds = [
        { l: 's', r: 1 },
        { l: 'm', r: 1 },
        { l: 'mm', r: 59, d: 'minute' },
        { l: 'h', r: 1 },
        { l: 'hh', d: 'hour' },
        { l: 'd', r: 0 },
        { l: 'dd', r: 0, d: 'day' },
        { l: 'M', r: 0 },
        { l: 'MM', r: 0, d: 'month' },
        { l: 'y', r: 0 },
        { l: 'yy', r: 0, d: 'year' },
    ];

    const locale = {
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: '%ds',
            m: '%dm',
            mm: '%dm',
            h: '%dh',
            hh: '%dh',
            d: '%d dayc',
            dd: '%d days',
            M: '%d month',
            MM: '%d monthsyy',
            y: '%d year',
            yy: '%d years',
        },
    };

    dayjs.extend(UpdateLocale);
    dayjs.extend(RelativeTime, { thresholds });
    dayjs.updateLocale('en', locale);
};

const configEs = () => {
    const thresholds = [
        { l: 's', r: 1 },
        { l: 'm', r: 1 },
        { l: 'mm', r: 59, d: 'minute' },
        { l: 'h', r: 1 },
        { l: 'hh', d: 'hour' },
        { l: 'd', r: 0 },
        { l: 'dd', r: 0, d: 'day' },
        { l: 'M', r: 0 },
        { l: 'MM', r: 0, d: 'month' },
        { l: 'y', r: 0 },
        { l: 'yy', r: 0, d: 'year' },
    ];

    const locale = {
        relativeTime: {
            future: 'en %s',
            past: '%s atrás',
            s: '%ds',
            m: '%dm',
            mm: '%dm',
            h: '%dh',
            hh: '%dh',
            d: '%d día',
            dd: '%d días',
            M: '%d mes',
            MM: '%d meses',
            y: '%d año',
            yy: '%d años',
        },
    };

    dayjs.extend(UpdateLocale);
    dayjs.extend(RelativeTime, { thresholds });
    dayjs.updateLocale('es', locale);
};